import DatePicker from "./index.vue";
import { register } from "@various/utils";

export const UiDatePicker = register.use(DatePicker, "component") as typeof DatePicker;

export * from "./src/component";
export default UiDatePicker;
